// import React, { useState, useEffect } from 'react';
// import { Navbar as BootstrapNavbar, Nav, Container } from 'react-bootstrap';
// import { Link, useLocation } from 'react-router-dom';
// import './Navbar.css';
// import logo from "../images/logo.png"

// const Navbar = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const [buttonClicked, setButtonClicked] = useState(false);
//   const location = useLocation();

//   useEffect(() => {
//     const handleScroll = () => {
//       const isScrolled = window.scrollY > 50;
//       setScrolled(isScrolled);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const isActive = (path) => {
//     return location.pathname === path;
//   };

//   return (
//     <BootstrapNavbar
//       expand="lg"
//       fixed="top"
//       className={scrolled ? 'navbar-scrolled' : 'navbar-transparent'}
//     >
//       <Container>
//         <BootstrapNavbar.Brand as={Link} to="/" className='m-w-50'>
//         {/*  */}
//           <div className="navbar-logo">
//            <span className="logo-name"><img className='logo-size' src={logo} alt="OM SHAKTI GOOD SERVICES"/></span> 
//             {/* <div className="logo-circle">
//               <span className="logo-text">OS</span>
//             </div>
//             <span className="logo-name">OM SHAKTI<br />GOOD SERVICES</span> */}
//           </div>
//         </BootstrapNavbar.Brand>
//         <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
//         <BootstrapNavbar.Collapse id="basic-navbar-nav">
//           <Nav className="ms-auto">
//             <Nav.Link as={Link} to="/" className={isActive('/') ? 'active' : ''}>
//               Home
//             </Nav.Link>
//             <Nav.Link as={Link} to="/services" className={isActive('/services') ? 'active' : ''}>
//               Services
//             </Nav.Link>
//             <Nav.Link as={Link} to="/about" className={isActive('/about') ? 'active' : ''}>
//               About
//             </Nav.Link>
//             <Nav.Link as={Link} to="/gallery" className={isActive('/gallery') ? 'active' : ''}>
//               Gallery
//             </Nav.Link>
//              <Nav.Link as={Link} to="/contact" className={isActive('/contact') ? 'active' : ''}>
//               Contact
//             </Nav.Link>
//           </Nav>
//         </BootstrapNavbar.Collapse>
//       </Container>
//     </BootstrapNavbar>
//   );
// };

// export default Navbar;



import React, { useState, useEffect } from 'react';
import { Navbar as BootstrapNavbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from "../images/logo.png";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <BootstrapNavbar
      expand="lg"
      fixed="top"
      expanded={expanded}
      onToggle={(val) => setExpanded(val)}
      className={scrolled ? 'navbar-scrolled' : 'navbar-transparent'}
    >
      <Container>
        <BootstrapNavbar.Brand as={Link} to="/" className="m-w-50" onClick={() => setExpanded(false)}>
          <div className="navbar-logo">
            <span className="logo-name">
              <img className="logo-size" src={logo} alt="OM SHAKTI GOOD SERVICES" />
            </span>
          </div>
        </BootstrapNavbar.Brand>

        <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
        <BootstrapNavbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" className={isActive('/') ? 'active' : ''} onClick={() => setExpanded(false)}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/services" className={isActive('/services') ? 'active' : ''} onClick={() => setExpanded(false)}>
              Services
            </Nav.Link>
            <Nav.Link as={Link} to="/about" className={isActive('/about') ? 'active' : ''} onClick={() => setExpanded(false)}>
              About
            </Nav.Link>
            <Nav.Link as={Link} to="/gallery" className={isActive('/gallery') ? 'active' : ''} onClick={() => setExpanded(false)}>
              Gallery
            </Nav.Link>
            <Nav.Link as={Link} to="/contact" className={isActive('/contact') ? 'active' : ''} onClick={() => setExpanded(false)}>
              Contact
            </Nav.Link>
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar;
